import { useFilterStore } from "@/Tailwind//Stores/filters";
import { computed } from "vue";

export function useFilters(filterStoreKey) {
    const filterStore = useFilterStore();

    const filterValue = (filterKey) => {
        return filterStore[filterStoreKey][filterKey];
    };

    const handleFilterChange = (key, value) => {
        if (!filterStore[filterStoreKey]) {
            console.error(
                "The specified store key is not present in the filter store."
            );
        }

        filterStore[filterStoreKey][key] = value;
    };

    const sort = computed(() => ({
        sort_by: filterStore[filterStoreKey].sort_by,
        order_by: filterStore[filterStoreKey].order_by,
    }));

    const handleSort = (column, direction, callback = () => {}) => {
        filterStore[filterStoreKey].sort_by = column;
        filterStore[filterStoreKey].order_by = direction;

        callback();
    };

    const getSortValue = (column) => {
        if (filterStore[filterStoreKey].sort_by === column) {
            return filterStore[filterStoreKey].order_by;
        }

        return null;
    };

    return {
        filterValue,
        handleFilterChange,
        sort,
        handleSort,
        getSortValue,
    };
}
